interface WheelLoaderProps {
  width?: number
  className?: string
}

// wheel2.png dimensions: 669x373 (aspect ratio ~1.79:1)
const ASPECT_RATIO = 373 / 669

export default function WheelLoader({ width = 48, className = '' }: WheelLoaderProps) {
  const height = width * ASPECT_RATIO

  return (
    <>
      <style>{`
        @keyframes wheel-spin {
          0% { transform: rotate(0deg); }
          25% { transform: rotate(90deg); }
          30% { transform: rotate(90deg); }
          55% { transform: rotate(180deg); }
          60% { transform: rotate(180deg); }
          85% { transform: rotate(270deg); }
          90% { transform: rotate(270deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <img
        src="/wheel2.png"
        alt="Loading..."
        className={className}
        style={{
          width,
          height,
          animation: 'wheel-spin 4s ease-in-out infinite',
          transformOrigin: 'center center',
        }}
      />
    </>
  )
}
